'use client'
import { useMediaQuery } from '@icouldeat/core'
import { ChartDesktop } from './chart.desktop'
import { ChartMobile } from './chart.mobile'
import { type TripType } from '_/services/trips/get-trip.schema'

interface ChartProps {
	className?: string
	trip: TripType
}

export const ChartGuests = ({ trip }: ChartProps) => {
	const isMobile = useMediaQuery('(max-width: 768px)')

	if (isMobile) {
		return <ChartMobile trip={trip} />
	} else {
		return <ChartDesktop trip={trip} />
	}
}

export default ChartGuests
